(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pharmacy-brand-directory"] && !Shopify.designMode) return;
  try {
    
  function initPharmacyBrandSearch() {
    const input = document.querySelector('#pharmacy-brand-search');
    if (!input || input.dataset.initialized) return;
    input.dataset.initialized = 'true';
    const directory = input.closest('.pharmacy-directory');
    const cards = [...directory.querySelectorAll('[data-brand-title]')];
    const count = directory.querySelector('[data-brand-count]');
    const empty = directory.querySelector('.pharmacy-directory__empty');
    const normalize = value => value.normalize('NFD').replace(/[̀-ͯ]/g, '').toLocaleLowerCase('es').trim();
    const update = () => {
      const term = normalize(input.value);
      let visible = 0;
      cards.forEach(card => { const match = normalize(card.dataset.brandTitle).includes(term); card.hidden = !match; if (match) visible++; });
      count.textContent = visible;
      empty.hidden = visible !== 0;
    };
    input.addEventListener('input', update);
    input.addEventListener('search', update);
    update();
  }
  initPharmacyBrandSearch();
  document.addEventListener('shopify:section:load', initPharmacyBrandSearch);

  } catch(e) { console.error(e); }
})();
})();
